import {
  Directive,
  Input,
  OnDestroy,
  OnInit,
  Optional,
  Self,
} from '@angular/core';
import {
  ControlValueAccessor,
  FormControl,
  FormControlDirective,
  FormControlName,
  NgControl,
  NgModel,
} from '@angular/forms';
import { Subscription } from 'rxjs';

@Directive()
export class FormFieldBase implements OnInit, OnDestroy, ControlValueAccessor {
  /**
   * Form field label property
   *
   * @default ''
   * @type string
   * @memberof FormFieldBase
   */
  @Input() label: string;

  /**
   * Form field placeholder property
   *
   * @default ''
   * @type string
   * @memberof FormFieldBase
   */
  @Input() placeholder = '';

  /**
   * Form field mask property, used for input masking
   *
   * @default ''
   * @type string
   * @memberof FormFieldBase
   */
  @Input() mask: string;

  /**
   * Form field disabled property
   *
   * @default false
   * @type boolean
   * @memberof FormFieldBase
   */
  @Input() disabled = false;

  /**
   * Form field required property
   *
   * @default false
   * @type boolean
   * @memberof FormFieldBase
   */
  @Input() required = false;

  private subscription: Subscription;

  constructor(@Optional() @Self() public ngControl: NgControl) {
    if (this.ngControl != null) {
      this.ngControl.valueAccessor = this;
    }
  }

  control: FormControl;

  writeValue(obj: any): void {
    // TODO: implement
  }
  registerOnChange(fn: (_: any) => void): void {
    // TODO: implement
  }

  registerOnTouched(fn: any): void {
    // TODO: implement
  }

  ngOnInit() {
    if (!this.ngControl) throw new Error('ngControl is undefined');
    if (
      this.ngControl instanceof FormControlName ||
      this.ngControl instanceof FormControlDirective
    ) {
      this.control = this.ngControl.control;
    } else if (this.ngControl instanceof NgModel) {
      this.control = this.ngControl.control;
      this.subscription = this.control.valueChanges.subscribe((x) =>
        this.ngControl.viewToModelUpdate(this.control.value),
      );
    } else if (!this.ngControl) {
      this.control = new FormControl();
    }
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
}
